import React from 'react';
import {FaEraser, FaExclamationTriangle, FaRegImages, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import Button from "../../../../components/button/button.jsx";
import InputDatetime from "../../../../components/input/input-datetime.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import InputSlider from "../../../../components/input/input-slider.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {errMessageI18n} from "../utils/individual-passage-search-utils.js";
import {MaskDefault} from "../../../../utils/mask.js";
import Alert from "../../../../components/alert/alert.jsx";

const ACCEPTED_TYPES = ['jpg', 'jpeg', 'image/jpg', 'image/jpeg'];

const PassageFilters = ({
                            filters,
                            setFilters,
                            threshold,
                            setThreshold,
                            imgSrc,
                            setImgSrc,
                            providers,
                            facialRecognitionStatus,
                            onSearch,
                            onClear
                        }) => {

    const handleInput = ({target: {id, value}}) => setFilters(prev => ({...prev, [id]: value}));

    const handleDate = (item, value) => setFilters(prev => ({...prev, [item]: value}));

    const processImg = (file) => {
        if (!file) return;

        if (!ACCEPTED_TYPES.includes(file.type)) {
            projectUtils.swalErrorMessage("", errMessageI18n("facegateway.image.type.unsupported"), "Ok");
            return;
        }

        const reader = new FileReader();

        reader.onload = ({target: {result}}) => setImgSrc(result);

        reader.readAsDataURL(file);
        setFilters(prev => ({...prev, image: file}));
    };

    const onClick = () => {
        if (filters.cpf) return;

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/jpeg';
        input.onchange = event => processImg(event.target.files[0]);
        input.click();
    };

    const onDrop = (e) => {
        e.preventDefault();
        if (filters.cpf) return;

        let file;
        if (e.dataTransfer.items) {
            const items = [...e.dataTransfer.items];
            const firstFileIndex = items.findIndex(item => item.kind === 'file');
            file = items[firstFileIndex]?.getAsFile();
        } else {
            file = [...e.dataTransfer.files][0];
        }

        processImg(file);
    };

    const removeImg = () => {
        setFilters(prev => ({...prev, image: undefined}));
        setImgSrc(undefined);
    };

    return (
        <Card className={"ips-default-height w-[20%] flex flex-col"}>
            <Card.Body className={"flex flex-col gap-3 overflow-auto flex-1"}>
                <InputDatetime
                    id={"dtStart"}
                    label={"Data inicial *"}
                    dateFormat={"LL"}
                    selected={filters.dtStart}
                    onChange={(date) => handleDate("dtStart", date)}
                />

                <InputDatetime
                    id={"dtEnd"}
                    label={"Data final *"}
                    dateFormat={"LL"}
                    selected={filters.dtEnd}
                    onChange={(date) => handleDate("dtEnd", date)}
                />

                <SelectComponent
                    value={filters.providers}
                    options={providers ?? []}
                    label={"Câmeras / Entidades"}
                    onChange={(value) => setFilters(prev => ({...prev, providers: value ?? []}))}
                    isMulti
                />

                <InputSlider
                    label={"Confiança da leitura (%):"}
                    value={threshold}
                    setValue={setThreshold}
                    min={0}
                    max={100}
                />

                <InputCheckbox
                    id={"onlyMatches"}
                    label={"Somente monitorados"}
                    checked={filters.onlyMatches}
                    onChange={({target: {checked}}) => setFilters(prev => ({...prev, onlyMatches: checked}))}
                />

                <InputForm
                    id={"cpf"}
                    value={filters.cpf}
                    onChange={handleInput}
                    onBlur={handleInput}
                    label={"CPF"}
                    disabled={!!filters.image}
                    mask={MaskDefault.cpf}
                />

                <div className={"ips-divider font-bold"}>Ou</div>

                {
                    facialRecognitionStatus === false &&
                    <Alert target={"danger"} className={"text-sm! flex items-center gap-2"}>
                        <FaExclamationTriangle /> Sistema de reconhecimento facial não configurado.
                    </Alert>
                }

                <div
                    className={"bg-white rounded-[0.5rem] border border-[#ededed] relative h-[150px] overflow-hidden" + (facialRecognitionStatus === false ? " pointer-events-none opacity-[0.45]" : "")}
                >
                    {
                        !filters.image ?
                            <div
                                className={"w-full h-full flex justify-center items-center flex-col" + (filters.cpf ? " bg-gray-200 pointer-events-none" : " cursor-pointer")}
                                onClick={onClick}
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={onDrop}
                            >
                                <FaRegImages className={"ips-img-content"}/>
                                <h4 className={"text-center font-bold"}>
                                    Clique aqui ou<br/> arraste e solte um arquivo
                                </h4>
                            </div>
                            :
                            <div
                                className={"h-full w-full overflow-hidden"}
                                style={{
                                    backgroundPosition: "50% center",
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundImage: imgSrc ? `url(${imgSrc})` : ""
                                }}
                            >
                                {
                                    imgSrc &&
                                    <Button target={"danger"} className={"absolute top-[5px] right-[5px]"} onClick={removeImg}>
                                        Remover
                                    </Button>
                                }
                            </div>
                    }
                </div>
            </Card.Body>

            <Card.Footer>
                <div className={"w-full grid grid-cols-1 2xl:grid-cols-2 gap-2"}>
                    <Button target={"primary"} className={"w-full"} onClick={onSearch}>
                        Aplicar
                    </Button>
                    <Button target={"primary-outline"} className={"w-full"} onClick={onClear}>
                        Limpar
                    </Button>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default PassageFilters;
